import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	quickReplyCard: {
		padding: "8px"
	},
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[700]
	},
	messageContainer: {
		order: 1,
		[theme.breakpoints.down("sm")]: {
			order: 2
		}
	},
	previewContainer: {
		order: 2,
		[theme.breakpoints.down("sm")]: {
			order: 1
		}
	},
	iconButton: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		width: "64px",
		height: "64px",
		color: colors.gray[700],
		fontSize: "20px"
	},
	buttonPrimaryColorOutLined: {
		border: "1px solid",
		boxShadow: "none",
		borderColor: "rgba(126, 13, 214, 0.12)",
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		letterSpacing: 0.4,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent"),
			boxShadow: "none"
		}
	}
}))

export default useStyles
